export default "__VITE_ASSET__DvE_l9Xh__"